"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMetricsAttribute = generateMetricsAttribute;
exports.MetricsTracker = void 0;

var _utils = require("@sm/utils");

var _enums = _interopRequireDefault(require("./types/enums"));

var _BaseMetricsTracker = require("./BaseMetricsTracker");

var _DataAnalyticsMetricsSubscriber = _interopRequireDefault(require("./subscribers/DataAnalyticsMetricsSubscriber"));

var _LoggingMetricsSubscriber = _interopRequireDefault(require("./subscribers/LoggingMetricsSubscriber"));

var _GTMMeticsSubscriber = _interopRequireDefault(require("./subscribers/GTMMeticsSubscriber"));

var _FacebookPixelSubscriber = _interopRequireDefault(require("./subscribers/FacebookPixelSubscriber"));

var _MixPanelSubscriber = _interopRequireDefault(require("./subscribers/MixPanelSubscriber"));

var _AmplitudeSubscriber = _interopRequireDefault(require("./subscribers/AmplitudeSubscriber"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _getClientEnvironment = (0, _utils.getClientEnvironmentDetails)(),
    isBrowser = _getClientEnvironment.isBrowser;

var glob = isBrowser ? window : global; // Import/require only in the browser

var delegatedEvents = isBrowser ? require('delegated-events') : null;
/**
 * Generates a string of event data that can be used in an HTML attribute
 *
 * @param eventData The name and data of the event
 * @returns A formatted strong of the eventData passed in
 */

function generateMetricsAttribute(eventData) {
  return JSON.stringify({
    name: eventData.name || _enums.default.ELEMENT_INTERACTION,
    data: eventData.data
  });
}

var MetricsTracker = _objectSpread(_objectSpread({}, (0, _BaseMetricsTracker.createMetricsTracker)(glob)), {}, {
  /**
   * Initializes the events and configuration of the MetricsTracker
   *
   * @override
   * @param config
   * @returns
   */
  initialize: function initialize(config) {
    var root = (0, _BaseMetricsTracker.setupRoot)(glob);
    root.config = config;
    root.digitalData = (0, _BaseMetricsTracker.getCleanDigitalData)(config.user.id);
    setupEvents();
    return root;
  },
  reset: function reset() {
    var root = (0, _BaseMetricsTracker.getRoot)(glob);
    root.digitalData = (0, _BaseMetricsTracker.getCleanDigitalData)(root.config.user.id);
    root.subscribers = [];
    root.automaticSubscribers = []; // Add the mandatory dataAnalytics subscriber

    this.addSubscriber(_DataAnalyticsMetricsSubscriber.default); // Add the mandatory logging subscriber

    this.addSubscriber(_LoggingMetricsSubscriber.default); // Add Google Tag Manager dataLayer subscriber

    MetricsTracker.addSubscriber(_GTMMeticsSubscriber.default); // Add Facebook Pixel subscriber

    MetricsTracker.addSubscriber(_FacebookPixelSubscriber.default); // Add MixPanel Subscriber

    MetricsTracker.addSubscriber(_MixPanelSubscriber.default); // Add MixPanel Automatic Subscriber

    MetricsTracker.addAutomaticSubscriber(_MixPanelSubscriber.default); // Add Amplitude Subscriber

    MetricsTracker.addSubscriber(_AmplitudeSubscriber.default);
    return root;
  }
});

exports.MetricsTracker = MetricsTracker;

function setupEvents() {
  if (!isBrowser) {
    return;
  }

  if (window && window.SM && window.SM.MetricsTracker) {
    // only create one event listener on the document
    // this makes it safe for consumer apps to call initialize multiple times
    return;
  }
  /**
   * Add on click event listener
   * Note - this is done in the getInstance method; hence, until this
   * method is called, the event handler would never be bound.
   */


  delegatedEvents.on('click', '[data-sm-metrics]', function gce(event) {
    if (event && event.currentTarget) {
      var metricsData = event.currentTarget.getAttribute('data-sm-metrics');

      if (metricsData) {
        var metricsDataJSON = JSON.parse(metricsData);
        var eventData = metricsDataJSON.data;
        MetricsTracker.track({
          name: metricsDataJSON.name || _enums.default.ELEMENT_INTERACTION,
          data: eventData
        });
      }
    }
  }); // Add the mandatory dataAnalytics subscriber

  MetricsTracker.addSubscriber(_DataAnalyticsMetricsSubscriber.default); // Add the mandatory logging subscriber

  MetricsTracker.addSubscriber(_LoggingMetricsSubscriber.default); // Add Google Tag Manager dataLayer subscriber

  MetricsTracker.addSubscriber(_GTMMeticsSubscriber.default); // Add Facebook Pixel subscriber

  MetricsTracker.addSubscriber(_FacebookPixelSubscriber.default); // Add MixPanel Subscriber

  MetricsTracker.addSubscriber(_MixPanelSubscriber.default); // Add Amplitude Subscriber

  MetricsTracker.addSubscriber(_AmplitudeSubscriber.default);
  setupAutomaticEvents();
  window.SM = window.SM || {};
  window.SM.MetricsTracker = MetricsTracker;
}

function setupAutomaticEvents() {
  var clickableLinks = ['.wds-button', '.wds-link', 'a', 'wds-switch__native', 'wds-checkbox__native', 'wds-radio__native', 'wds-list__item', 'wds-close', 'wds-popout__trigger', 'wds-has-menu', 'wds-slider__handle', 'wds-tab__tab-btn'];
  delegatedEvents.on('click', clickableLinks.join(','), function gce(event) {
    if (!event.target) {
      return;
    }

    var name = event.type;
    var target = event.target;
    var inputTarget = target;
    MetricsTracker.automaticTrack({
      name: _enums.default.ELEMENT_INTERACTION,
      data: {
        actionType: name,
        actionFlow: 'automatic',
        class: target.className,
        text: target.innerText,
        checked: inputTarget.checked || undefined,
        value: inputTarget.value || undefined
      }
    });
  }); // Add MixPanel Subscriber

  MetricsTracker.addAutomaticSubscriber(_MixPanelSubscriber.default);
}